const RecaptchaLoader = {
    loaded: false,
    loading: false,
    callbacks: [],

    async load() {
        if (this.loaded) {
            return Promise.resolve();
        }

        if (this.loading) {
            return new Promise((resolve) => {
                this.callbacks.push(resolve);
            });
        }

        this.loading = true;

        return new Promise((resolve, reject) => {
            // Check if already loaded
            if (window.grecaptcha) {
                this.loaded = true;
                this.loading = false;
                resolve();
                return;
            }

            // Create script element
            const script = document.createElement('script');
            const siteKey = touchitData.recaptcha_site_key;
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.async = true;
            script.defer = true;

            script.onload = () => {
                this.loaded = true;
                this.loading = false;
                resolve();
                
                // Execute any pending callbacks
                this.callbacks.forEach((callback) => {
                    callback();
                });
                this.callbacks = [];
            };

            script.onerror = (error) => {
                this.loading = false;
                reject(new Error('Failed to load reCAPTCHA'));
            };

            document.head.appendChild(script);
        });
    },

    async execute(action) {
        try {
            await this.load();
        } catch (error) {
            throw error;
        }
        
        return new Promise((resolve, reject) => {
            if (typeof grecaptcha === 'undefined') {
                reject(new Error('reCAPTCHA not available'));
                return;
            }

            grecaptcha.ready(() => {
                grecaptcha.execute(touchitData.recaptcha_site_key, { action })
                    .then((token) => {
                        resolve(token);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        });
    }
};

export default RecaptchaLoader;
